import App from "./App.vue";
import router from "./router";
import { auth } from "@/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { createApp, type App as VueApp } from "vue";

let appInstance: VueApp<Element> | null = null;

onAuthStateChanged(auth, () => {
  if (!appInstance) {
    appInstance = createApp(App).use(router);
    appInstance.mount("#app");
  }
});
